export default __webpack_public_path__ + "static/fall3-6cff807050f30c50d2870ebf25e3d845.webp";